import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function PerfectFor() {
  const {
    t
  } = useLanguage();
  return <section id="perfect-for" className="py-32 lg:py-48 bg-texture-dark text-cream" data-id="element-181">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-14" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="max-w-3xl" data-id="element-183">
          <div className="flex items-center gap-3 text-caramel text-[10px] tracking-[0.4em] uppercase mb-10" data-id="element-184">
            <span className="w-10 h-px bg-caramel/40" data-id="element-185" />
            {t.perfectFor.eyebrow}
          </div>
          <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-8xl text-cream leading-[0.95] tracking-[-0.02em] font-light" data-id="element-186">
            {t.perfectFor.title1}
            <br data-id="element-187" />
            <span className="italic font-extralight" data-id="element-188">
              {t.perfectFor.title2}
            </span>
          </h2>
        </motion.div>

        <div className="mt-24 lg:mt-32 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-2 lg:gap-y-4" data-id="element-189">
          {t.perfectFor.moments.map((m, i) => <motion.div key={m.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.7,
          delay: i % 3 * 0.1
        }} className="group py-10 border-t border-cream/10" data-id="element-190">
              <div className="flex items-baseline gap-4 mb-6" data-id="element-191">
                <span className="font-serif italic text-caramel text-sm" data-id="element-192">
                  0{i + 1}
                </span>
              </div>
              <h3 className="font-serif text-2xl lg:text-3xl text-cream font-light tracking-[-0.01em] group-hover:italic transition-all duration-500" data-id="element-193">
                {m.title}
              </h3>
              <p className="mt-4 text-cream/55 leading-[1.7] text-[14px] max-w-xs" data-id="element-194">
                {m.copy}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}